import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import {
  API_URL,
  CHAT_CONVERSATION_GET,
  CHAT_CONVERSATION_LOAD_MORE,
  CHAT_CONVERSATION_PUSH_MESSAGE,
  CHAT_CONVERSATION_SUCCESS,
  CHAT_ROOMS_GET,
  CHAT_ROOMS_SUCCESS,
  SEARCH_CONVERSATIONS,
  ADD_INDIVIDUAL_GROUPS,
  NEW_GROUP_CREATION,
  GET_CHAT_CONVERSATIONS,
  CHAT_NEW_ROOM,
  DELETE_MESSAGE,
  GLOBAL_CHAT,
  UPDATE_MESSAGE,
  FATCH_USERS_TO_GROUP,
  ADD_GROUP,
  GROUP_INFO,
  SEARCH_CONVERSATION_GROUP,
  ADDUSER_TO_GROUP,
  USER_LEAVE_GROUP,
  ADMIN_ACCESS,
  REMOVE_GROUP_ADMIN,
  UPDATE_GROUP_INFO,
  CHAT_API_URL,
  DELETE_CONVERSATION,
  CHAT_DELETE_MESSAGE,
  CHAT_WIDGET_USER_CREATE,
  ADD_GROUPS_CHAT_WIDGET,
  USER_LOGIN_WIDGET,
  CHAT_WIDGET_CONVERSATION,
  CHAT_WIDGET_CONVERSATION_PUSH_MESSAGE,
  ADD_USER_TO_GROUP_CHAT_WIDGET,
} from "../constants/type";

export const getChatRooms = (userid, creatingGroup) => async (dispatch) => {
  if (!creatingGroup) {
    dispatch({ type: CHAT_ROOMS_GET });
  }
  return await axios
    .post(`${API_URL}/api/Chatting/FetchMyConversationsList`, { userid })
    .then((response) => {
      dispatch({
        type: CHAT_ROOMS_SUCCESS,
        payload: response.data.data,
      });
      return response.data.data;
    });
};

export const getChatConversations =
  (groupid, userid, skip = 0, take = 10) =>
  async (dispatch) => {
    dispatch({ type: CHAT_CONVERSATION_GET });
    await axios({
      method: "post",
      url: `${API_URL}/api/Chatting/FetchMyConversationsById`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        groupid: groupid,
        userid: userid,
        skip: skip,
        take: take,
      },
    })
      .then((response) => {
        dispatch({
          type: CHAT_CONVERSATION_SUCCESS,
          data: response.data,
        });

        return Promise.resolve([]);
      })
      .catch((res) => console.log(res));
  };

export const loadMoreChatConversations =
  (groupid, userid, skip, take = 10) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/Chatting/FetchMyConversationsById`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        groupid: groupid,
        userid: userid,
        skip: skip,
        take: take,
      },
    })
      .then((response) => {
        dispatch({
          type: CHAT_CONVERSATION_LOAD_MORE,
          data: response.data,
        });
        return Promise.resolve([]);
      })
      .catch((res) => console.log(res));
  };

export const UpdateConversation =
  (msgs, offline, deleteMessage) => async (dispatch) => {
    if (offline) {
      dispatch({
        type: CHAT_CONVERSATION_PUSH_MESSAGE,
        payload: { msgs, offline },
      });
    } else if (deleteMessage) {
      dispatch({
        type: CHAT_CONVERSATION_PUSH_MESSAGE,
        payload: { msgs, offline, deleteMessage },
      });
    } else {
      dispatch({
        type: CHAT_CONVERSATION_PUSH_MESSAGE,
        payload: msgs,
      });
    }
  };

export const NewConversation = (conversation) => async (dispatch) => {
  //UPDATE:07
  dispatch({
    type: CHAT_ROOMS_SUCCESS,
    payload: conversation,
  });
};

export const deleteMessage = (message) => async (dispatch) => {
  dispatch({
    type: DELETE_MESSAGE,
    payload: message,
  });
};

export const SearchConversations = (query, userid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Chatting/SearchConversations`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      querystring: query,
      userid: userid,
    },
  }).then((response) => {
    dispatch({
      type: SEARCH_CONVERSATIONS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const EmptyAddGroupState = () => async (dispatch) => {
  dispatch({ type: "EMPTY_INDIVIDUAL_STATE" });
};

export const addIndividualGroups =
  (userId, groupDescription, groupUser) => async (dispatch) => {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Chatting/AddIndividualGroups`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userId,
        groupdescription: groupDescription,
        groupuser: groupUser,
      },
    });
    dispatch({
      type: ADD_INDIVIDUAL_GROUPS,
      data: response.data,
    });
    return response.data;
  };

export const globalChat = (data) => async (dispatch) => {
  dispatch({
    type: GLOBAL_CHAT,
    data: data,
  });
};
export const UpdateMessage = (userId, groupUser) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Chatting/UpdateMessage`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid: userId,
      groupid: groupUser,
    },
  }).then((response) => {
    dispatch({
      type: UPDATE_MESSAGE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchUsersToGroup = () => async (dispatch) => {
  const sessionId = window.localStorage.getItem("session-id");
  await axios({
    method: "post",
    url: `${API_URL}/api/Chatting/FetchUsersToGroup`,
    headers: {
      "Content-Type": "application/json",
      "session-id": sessionId,
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FATCH_USERS_TO_GROUP,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddGroups =
  (userid, groupname, groupdescription, groupicon, groupUser) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/Chatting/AddGroups`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid,
        groupname,
        groupdescription,
        groupicon,
        groupUser,
      },
    }).then((response) => {
      dispatch({
        type: ADD_GROUP,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const GroupInfo = (userid, groupid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Chatting/GroupInfo`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid,
      groupid,
    },
  }).then((response) => {
    dispatch({
      type: GROUP_INFO,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const SearchConversationOnGroup =
  (groupid, querystring) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/Chatting/SearchConversationOnGroup`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        groupid,
        querystring,
      },
    }).then((response) => {
      dispatch({
        type: SEARCH_CONVERSATION_GROUP,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const AddUserToGroup =
  (groupid, userid, userToGroup) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/Chatting/AddUserToGroup`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        groupid,
        userid,
        userToGroup,
      },
    }).then((response) => {
      dispatch({
        type: ADDUSER_TO_GROUP,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const UserLeaveGroup =
  (groupid, userid, userToGroup) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/Chatting/UserLeaveGroup`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        groupid,
        userid,
        userToGroup,
        actionByUserid: window.localStorage.getItem("userid"),
      },
    }).then((response) => {
      dispatch({
        type: USER_LEAVE_GROUP,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const Adminaccess = (groupid, changeAdminAccess) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${CHAT_API_URL}/api/Chatting/Adminaccess`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      groupid,
      changeAdminAccess,
      userId: window.localStorage.getItem("userid"),
    },
  }).then((response) => {
    dispatch({
      type: ADMIN_ACCESS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const RemoveGroupAdmin = (groupid, userid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Chatting/RemoveGroupAdmin`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      groupid,
      userid,
    },
  }).then((response) => {
    dispatch({
      type: REMOVE_GROUP_ADMIN,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const UpdateGroupInfo =
  (groupid, groupname, groupicon) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/Chatting/UpdateGroupInfo`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        groupid,
        groupname: groupname,
        groupicon: groupicon,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_GROUP_INFO,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const PinChat =
  ({ groupid }) =>
  async (dispatch) => {
    const response = await axios.post(
      `${API_URL}/api/Chatting/${groupid}/pin`,
      null,
    );
    if (response.status === 200) {
      const currentUserId = window.localStorage.getItem("userid");
      dispatch(getChatRooms(currentUserId));
    }
  };

export const UnPinChat =
  ({ groupid }) =>
  async (dispatch) => {
    const response = await axios.post(
      `${API_URL}/api/Chatting/${groupid}/unpin`,
      null,
    );
    if (response.status === 200) {
      const currentUserId = window.localStorage.getItem("userid");
      dispatch(getChatRooms(currentUserId));
    }
  };

export const ArchiveChat =
  ({ groupid }) =>
  async (dispatch) => {
    const response = await axios.post(
      `${API_URL}/api/Chatting/${groupid}/archive`,
      null,
    );
    if (response.status === 200) {
      const currentUserId = window.localStorage.getItem("userid");
      dispatch(getChatRooms(currentUserId));
      handleGeneralNotification(
        { notificationType: "CHAT_ARCHIVE", data: JSON.stringify({ groupid }) },
        false,
        10000,
      );
    }
  };

export const UnArchiveChat =
  ({ groupid }) =>
  async (dispatch) => {
    const response = await axios.post(
      `${API_URL}/api/Chatting/${groupid}/unarchive`,
      null,
    );
    if (response.status === 200) {
      const currentUserId = window.localStorage.getItem("userid");
      dispatch(getChatRooms(currentUserId));
    }
  };

export const DeleteChat = (room) => async (dispatch) => {
  const response = await axios.post(
    `${API_URL}/api/Chatting/${room.groupid}/delete`,
    null,
  );
  if (response.status === 200) {
    dispatch({ type: DELETE_CONVERSATION, data: room });
    handleGeneralNotification(
      { notificationType: "CHAT_DELETE", data: JSON.stringify(room) },
      false,
      10000,
    );
  }
};

export const UndoDeleteChat = (room) => async (dispatch) => {
  const response = await axios.post(
    `${API_URL}/api/Chatting/${room.groupid}/undo-delete`,
    null,
  );
  if (response.status === 200) {
    dispatch({ type: DELETE_CONVERSATION, data: room });
  }
};

export const DeleteMessage = (messageid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Chatting/DeleteMessage`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        messageid,
      },
    });
    dispatch({
      type: CHAT_DELETE_MESSAGE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

//chat widget
export const createChatWidgetUser = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/ChatWidget/CreateUser`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: CHAT_WIDGET_USER_CREATE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error("error", error);
  }
};

export const chatWidgetLogin =
  (email, password, companyid, env = "") =>
  (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/ChatWidget/ValidateLogin`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email: email,
        password: password,
        environment: env,
        companyid: companyid,
      },
    }).then((response) => {
      dispatch({
        type: USER_LOGIN_WIDGET,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const getChatWidgetConversations =
  (groupid, userid) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/ChatWidget/FetchMyConversationsById`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        groupid: groupid,
        userid: userid,
      },
    }).then((response) => {
      dispatch({
        type: CHAT_WIDGET_CONVERSATION,
        data: response.data,
      });

      return Promise.resolve([]);
    });
  };
export const UpdateWidgetConversation =
  (msgs, offline, deleteMessage) => async (dispatch) => {
    if (offline) {
      dispatch({
        type: CHAT_WIDGET_CONVERSATION_PUSH_MESSAGE,
        payload: { msgs, offline },
      });
    } else if (deleteMessage) {
      dispatch({
        type: CHAT_WIDGET_CONVERSATION_PUSH_MESSAGE,
        payload: { msgs, offline, deleteMessage },
      });
    } else {
      dispatch({
        type: CHAT_WIDGET_CONVERSATION_PUSH_MESSAGE,
        payload: msgs,
      });
    }
  };

export const AddChatWidgetGroups =
  (userid, groupname, groupDescription, groupicon, groupUser, type) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/ChatWidget/AddGroups`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid,
        groupname,
        groupDescription,
        groupicon,
        groupUser,
        type,
      },
    }).then((response) => {
      dispatch({
        type: ADD_GROUPS_CHAT_WIDGET,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const AddUserToGroupChatWidget =
  (groupid, userid, userToGroup) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/ChatWidget/AddUserToGroup`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        groupid,
        userid,
        userToGroup,
      },
    }).then((response) => {
      dispatch({
        type: ADD_USER_TO_GROUP_CHAT_WIDGET,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const GroupInfoChatWidget = (userid, groupid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/ChatWidget/GroupInfo`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid,
      groupid,
    },
  }).then((response) => {
    dispatch({
      type: GROUP_INFO,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const createTaskChat = (payload) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/ChatWidget/CreateTaskChat`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    return Promise.resolve([]);
  });
};

export const emptyLeaveGroupState = () => (dispatch) => {
  dispatch({ type: "EMPTY_GROUP_STATE", data: {} });
};
